const emailDomainList = ['naver.com', 'gmail.com', 'nate.com', 'hanmail.net', 'daum.net', 'kakao.com', 'yahoo.com'];

export default emailDomainList;
